import React from "react";
import AdnCard from "../common/adnCard/AdnCard";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import { Badge, Calendar, Row, Col } from "antd";
import { FollowUpEventTypeColor } from "../common/GeneralConfigurations";
import "./Calendar.css";

const CalendarForm = ({
    eventDateExists,
    handleSelectEvent,
    handleFollowUpEventClick,
    onPanelChange,
    handleDone,
    employeeFollowUpEvents,
    handleEventTypeChange,
    loading,
    monthHaveEvents,
    followUpEventType,
    users,
    meetingStatusOptions,
    meetingStatusChange,
}) => {
    const title = "Calendar";

    const dateCellRender = (event) => {
        let day = event.date();
        let month = event.month();
        let year = event.year();

        return (
            <ul className="events">
                {employeeFollowUpEvents.map((option, index) => {
                    if (
                        followUpEventType === "" ||
                        option.eventType === followUpEventType
                    ) {
                        let eventTypeColor, eventType, managerAcronym;
                        FollowUpEventTypeColor.forEach((item) => {
                            if (item.name === option.eventType) {
                                eventTypeColor = item.color;
                                eventType = item.name.substring(0, 6);
                            }
                        });
                        users.forEach((user) => {
                            if (option.doneById === user.id) {
                                managerAcronym = user.name
                            }
                        });

                        return (
                            eventDateExists(option, { day, month, year }) && (
                                <li key={index} className="eventItem">
                                    <Badge
                                        color={eventTypeColor}
                                        text={badgeTextAndButton(
                                            index,
                                            option.employeeName,
                                            option.id,
                                            eventTypeColor,
                                            option.date,
                                            eventType,
                                            option.doneById,
                                            managerAcronym
                                        )}
                                    />
                                </li>
                            )
                        );
                    }
                })}
            </ul>
        );
    };

    const monthCellRender = (event) => {
        const month = event.month();

        return (
            <ul className="events">
                {employeeFollowUpEvents.map((option, index) => {
                    if (
                        followUpEventType === "" ||
                        option.eventType === followUpEventType
                    ) {
                        let eventTypeColor, eventType, managerAcronym;

                        FollowUpEventTypeColor.forEach((item) => {
                            if (item.name === option.eventType) {
                                eventTypeColor = item.color;
                                eventType = item.name.substring(0, 6);
                            }
                        });

                        users.forEach((user) => {
                            managerAcronym = user.name
                        });

                        return (
                            monthHaveEvents(option, { month }) && (
                                <li key={index} className="eventItem">
                                    <Badge
                                        color={eventTypeColor}
                                        text={badgeTextAndButton(
                                            index,
                                            option.employeeName,
                                            option.id,
                                            eventTypeColor,
                                            option.date,
                                            eventType,
                                            option.doneById,
                                            managerAcronym
                                        )}
                                    />
                                </li>
                            )
                        );
                    }
                })}
            </ul>
        );
    };

    const badgeTextAndButton = (
        index,
        employeeName,
        employeeFollowUpEventId,
        eventTypeColor,
        date,
        eventType,
        doneBy,
        managerAcronym
    ) => {
        return (
            <div className="badgeText">
                {doneBy != null ? (
                    <span
                        onClick={() =>
                            handleFollowUpEventClick(
                                index,
                                employeeFollowUpEventId,
                                eventTypeColor
                            )
                        }
                    >
                        <text className="eventDone">
                            {employeeName + ", " + eventType + "-" + managerAcronym}
                        </text>
                    </span>
                ) : (
                    <span
                        onClick={() =>
                            handleFollowUpEventClick(
                                index,
                                employeeFollowUpEventId,
                                eventTypeColor
                            )
                        }
                    >
                        <text className="eventUndone">
                            <b> {employeeName + ", " + eventType}</b>
                        </text>
                    </span>
                )}
            </div>
        );
    };

    return (
        <>
            <AdnPageTitle title={title} />
            <AdnCard loading={loading}>
                <Row>
                    <Col span={12}>
                        <AdnDropdown
                            placeholder={"Event Type"}
                            options={FollowUpEventTypeColor}
                            isBadgeVisible={true}
                            handleChange={handleEventTypeChange}
                            allowClear
                        />
                    </Col>
                    <Col span={1}></Col>
                    <Col span={6}>
                        <AdnDropdown
                            placeholder={"Status"}
                            options={meetingStatusOptions}
                            handleChange={meetingStatusChange}
                            allowClear
                        />
                    </Col>
                </Row>

                <Row gutter={8}>
                    <Col>
                        <text style={{ color: "#00008A", fontSize: "15px" }}>
                            <b>Event undone</b>
                        </text>
                    </Col>
                    <text style={{ fontSize: "15px" }}>
                        <b>\</b>
                    </text>
                    <Col>
                        <text style={{ color: "#008000", fontSize: "15px" }}>
                            Event done
                        </text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Calendar
                            dateCellRender={dateCellRender}
                            onPanelChange={onPanelChange}
                            onSelect={handleSelectEvent}
                            monthCellRender={monthCellRender}
                            handleDone={handleDone}
                        />
                    </Col>
                </Row>
            </AdnCard>
        </>
    );
};

export default CalendarForm;
